namespace SorAraBul.Administration {
    export class RoleColumns {
        static columnsKey = 'Administration.Role';
    }
}
